import {dateTime} from "services/date";
import {QrCode} from "types/QrCode";

/**
 * Transform the given QR code by deserializing object properties
 *
 * @internal
 * @param qrCode
 */
export default function deserializeQrCode(qrCode: any): QrCode {
    qrCode.created_at = dateTime(qrCode.created_at)
    qrCode.updated_at = dateTime(qrCode.updated_at)
    qrCode.enabled_at = dateTime(qrCode.enabled_at)

    return qrCode;
}